'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z' });

var Star = function Star(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

Star = (0, _pure2.default)(Star);
Star.muiName = 'SvgIcon';

exports.default = Star;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/Star.js
// module id = 2885
// module chunks = 0